import React, { useEffect, useRef, useState } from "react";
import label from "../../labels/administration_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import {
  getAdvertisementlistByYear,
  getYearList,
} from "../../../common/actions/commonActions";
import { getrollNoQualifiedCandidate } from "../../actions/administrationActions";
import { SET_ROLLNO_QUALIFIED_CANDIDATE } from "../../../common/constants/ActionTypes";
import {
  getExamslistByAdvertisementId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";

const QualifiedCandidate = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors, reset } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [flagArray, setFlagArray] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");
  const session = JSON.parse(sessionStorage.getItem("session"));
  let { yearList, allYearList, alphabeticallist, } = useSelector(
    (state) => state.common,
    shallowEqual
  );
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0);
    dispatch({
      type: SET_ROLLNO_QUALIFIED_CANDIDATE,
      payload: [],
    });
    flagArray.length = 0;
    setPrintFlag(true);
    setReloadItem(!reloadItem);
  }, []);
  let { rollNoQualifiedCandidate, listRecommendationReports } = useSelector(
    (state) => state.administrationReducer,
    shallowEqual
  );
  let { objectiveStatusDataFlag, examList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  useEffect(() => {
    if (objectiveStatusDataFlag && objectiveStatusDataFlag.length > 0) {
      const flagValues = objectiveStatusDataFlag.map((item) => item.flag);
      const flagArrayBeforeInterviewCriteria = [];

      for (let i = 0; i < flagValues.length; i++) {
        if (flagValues[i] === "Result") {
          setFlagArray(flagArrayBeforeInterviewCriteria);
          break;
        } else {
          if (objectiveStatusDataFlag[i]?.flagStatus) {
            flagArrayBeforeInterviewCriteria.push(
              objectiveStatusDataFlag[i]
            );
          }
        }
      }
    }
  }, [objectiveStatusDataFlag]);

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0;
    }
    setPrintFlag(true);
    dispatch({
      type: SET_ROLLNO_QUALIFIED_CANDIDATE,
      payload: [],
    });
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  // const onAdvertisementChange = (ele) => {
  //   let selectedValue = ele;
  //   setSelectedAdvert(selectedValue);
  //   // selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
  //   setSaveButtonFlag(false);
  //   setPrintFlag(true);
  //   dispatch({
  //     type: SET_ROLLNO_QUALIFIED_CANDIDATE,
  //     payload: [],
  //   });
  //   setReloadItem(!reloadItem);
  // };

  const onAdvertisementChange = (ele) => {
    const selectedValue = ele;

    setSelectedAdvert(selectedValue);
    setSelectedExam("");

    if (selectedValue) {
      dispatch(getExamslistByAdvertisementId(selectedValue));
    }

    setSaveButtonFlag(true);
    setPrintFlag(true);

    dispatch({
      type: SET_ROLLNO_QUALIFIED_CANDIDATE,
      payload: [],
    });

    setReloadItem(!reloadItem);
  };

  const onCancelButton = () => {
    reset();
    dispatch({
      type: SET_ROLLNO_QUALIFIED_CANDIDATE,
      payload: [],
    });
  };
  const onSubmit = () => {
    dispatch(
      getrollNoQualifiedCandidate(
        selectedAdvert,
        selectedExam,
        setPrintFlag,
        setSaveButtonFlag,
      )
    );

    setReloadItem(!reloadItem);
  };
  const downloadPdf = () => {
    genPdf();
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      rollNoQualifiedCandidate.advertisementName +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    // htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;
    htmlContent.style.fontSize = "10px";
    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "RollNo_Qualified_Candidate.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;

          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          let dateX = pageWidth - dateWidth;
          if (i !== 1) {
            dateX = pageWidth - dateWidth - 0.4;
          }
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = rollNoQualifiedCandidate.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);

          const headerText1 = label.MPSC;
          const headerX1 = pdf.internal.pageSize.width / 2;
          const headerY1 = 0.6;

          pdf.setFontSize(10);
          pdf.text(headerText1, headerX1, headerY1, { align: "center" });

          const headerText2 = rollNoQualifiedCandidate.advertisementName;
          const headerX2 = pdf.internal.pageSize.width / 2;
          const headerY2 = 0.8;

          pdf.setFontSize(10);
          pdf.text(headerText2, headerX2, headerY2, { align: "center" });
        }

        pdf.save(`RollNo_Qualified_Candidate.pdf`);
      });
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setSaveButtonFlag(ele === "");
    setPrintFlag(true);
    setConfirmClicked(false);
    dispatch({
      type: SET_ROLLNO_QUALIFIED_CANDIDATE,
      payload: [],
    });
    setReloadItem(!reloadItem);
  };

  return (
    <div className="dashboardContentArea">
      <h5> {label.QualifiedCandidate} </h5>
      <div className="row dashboardCards">
        <div className="col-md-12">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList.map((element, index) => (
                        <option>{element}</option>
                      ))}
                  </select>
                  {_.get("selectedYear.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>
                <div className="form-group col-md-3">
                  <label className="float-left">
                    Select Exam
                    <span className="errorText">*</span>
                  </label>

                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => onExamChange(e.target.value)}
                  >
                    <option value="">
                      {commonLabels.COMBO_SELECT}
                    </option>

                    {examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))}
                  </select>

                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

                {/* <div className="form-group col-md-3">
                <label className="float-left">
                  {commonLabels.SelectExam}
                  <span className="errorText">*</span>
                </label>
                <select
                  className="form-control"
                  name="selectedExam"
                  ref={register({ required: true })}
                  onChange={(e) => {
                    onExamChange(e.target.value);
                  }}
                >
                  <option key={0} value="">
                    {commonLabels.COMBO_SELECT}
                  </option>
                  {examList &&
                    examList.length > 0 &&
                    examList
                      .filter(
                        (element) =>
                          element.isDeleted === false &&
                          element.isActive === true
                      )
                      .map((element, index) => (
                        <option key={index + 1} value={element.id}>
                          {element.name}
                        </option>
                      ))}
                </select>
                {_.get("selectedExam.type", errors) === "required" && (
                  <p className="errorText float-left">
                    {commonLabels.MANDATORY_FIELD_MESSAGE}
                  </p>
                )}
              </div> */}
              </div>

              {/* <div className="row pl-3 pr-3">
                {flagArray &&
                  flagArray.length > 0 &&
                  flagArray.map((ele, index) => (
                    <div className="d-flex p-2" key={index}>
                      <input
                        type="checkbox"
                        disabled
                        checked={ele.flagStatus === true && true}
                        className="form-control"
                      />
                      <label className="ml-1">{ele.flag}</label>
                    </div>
                  ))}
              </div> */}
              
              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <>
                        <button
                          type="reset"
                          className="btn btn-secondary mr-2"
                          onClick={() => onCancelButton()}
                        >
                          {commonLabels.BUTTON_CANCEL}
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary mr-2"
                          disabled={saveButtonFlag}
                          onClick={handleSubmit((e) => {
                            onSubmit(e);
                            setConfirmClicked(true);
                          })}
                        >
                          {commonLabels.BUTTON_VIEW}
                        </button>
                      </>
                    )}
                  {(session.roleName == "superadmin" ||
                    session.roleName == "secretary" ||
                    session.roleName == "desk officer") && (
                      <button
                        type="button"
                        className="btn btn-primary mr-2"
                        disabled={printFlag || !confirmClicked}
                        onClick={() => {
                          downloadPdf();
                        }}
                      >
                        {commonLabels.BUTTON_PRINT}
                      </button>
                    )}
                </div>
              </div>
            </div>
          </form>
        </div>
        {/* {rollNoQualifiedCandidate &&
          rollNoQualifiedCandidate.qualifiedCandidateRollNumbersDto &&
          rollNoQualifiedCandidate.qualifiedCandidateRollNumbersDto.length >
          0 && (
            <div
              ref={pdfRef}
              className="answerKeyTable w-100"
              id="qualified-candidate"
            >
              {rollNoQualifiedCandidate &&
                rollNoQualifiedCandidate.qualifiedCandidateRollNumbersDto &&
                rollNoQualifiedCandidate.qualifiedCandidateRollNumbersDto
                  .length > 0 &&
                rollNoQualifiedCandidate.qualifiedCandidateRollNumbersDto.map(
                  (item, index) => {
                    return (
                      <div className="table-Qualified-Candidate no-page-break">
                        <div className="centerName mb-1 p-2 border bold-text">
                          {item.examCenterName}
                        </div>
                        <div className="rollNumbersList mb-1 p-2 border">
                          {item.rollNumbers &&
                            item.rollNumbers.map((item) => (
                              <span className=" border p-1 rollNumber ">
                                {item}
                              </span>
                            ))}
                        </div>
                        <div className="totalCandidates mb-1 p-2 border mb-3 bold-text">
                          {label.numberOfCandidate}
                          {item.examCenterName + " : "}
                          {item.numberOfCandidates}
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
          )} */}
        {rollNoQualifiedCandidate?.postCriteriaWiseCandidates?.length > 0 && (
          <div
            ref={pdfRef}
            className="w-100 px-3"
            id="qualified-candidate"
          >
            {rollNoQualifiedCandidate.postCriteriaWiseCandidates.map(
              (post, postIndex) => (
                <div
                  key={postIndex}
                  className="card mb-4"
                  style={{ pageBreakInside: "avoid" }}
                >
                  {/* Post Name */}
                  <div className="card-header text-center">
                    <strong>{post.postName}</strong>
                  </div>

                  <div className="card-body p-0">
                    {post.qualifiedCandidates?.map((candidate, candidateIndex) => (
                      <table
                        key={candidateIndex}
                        className="table table-bordered mb-0"
                      >
                        <tbody>
                          {/* Center */}
                          <tr>
                            <td style={{ width: "180px" }}>
                              <strong>Exam Center</strong>
                            </td>

                            <td>{candidate.examCenterName}</td>
                          </tr>

                          {/* Roll Numbers */}
                          <tr>
                            <td>
                              <strong>Roll Numbers</strong>
                            </td>

                            <td>
                              <div className="d-flex flex-wrap">
                                {candidate.rollNumbers?.map(
                                  (rollNo, rollIndex) => (
                                    <span
                                      key={rollIndex}
                                      className="border rounded px-2 py-1 mr-2 mb-2"
                                    >
                                      {rollNo}
                                    </span>
                                  )
                                )}
                              </div>
                            </td>
                          </tr>

                          {/* Center Total */}
                          <tr>
                            <td>
                              <strong>Center Candidates</strong>
                            </td>

                            <td>{candidate.numberOfCandidates}</td>
                          </tr>
                        </tbody>
                      </table>
                    ))}
                  </div>

                  {/* Post Total */}
                  <div className="card-footer text-right">
                    <strong>
                      Total Candidates : {post.totalCandidates}
                    </strong>
                  </div>
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default QualifiedCandidate;
